
$('.product-item').each(function(){
    var $container = $(this); 

    $container.find('ul li').click(function(){
        $container.find('ul li').removeClass('selected');
        $(this).addClass('selected');

        var variantImage = $(this).find('.color-variant').attr('data-variant-image');
        var variantURL = $(this).find('.color-variant').attr('data-variant-url');
        if (variantImage) {
            $container.find('.product-image').removeAttr('srcset').attr('src', variantImage);
        }
        $container.find('.buy-now-btn').attr('href', variantURL);
    });
});
